import { axios } from '@/utils/request'

const api = {

 //////////////////////////////////////// 订单管理相关接口 ////////////////////////////////////////
  // 销售订单分页查询
  xsOrderPage: '/order/xs/page',
  // 生成销售订单单号
  genXsOrderNo: '/order/xs/genOrderNo',
  // 销售订单保存
  saveOrderXs: '/order/xs/save',
  // 销售订单作废
  cancelOrderXs: '/order/xs/cancel',
  // 销售子订单审核
  auditOrderDetailsXs: '/order/xs/auditDetails',
  // 销售子订单保存
  saveXsDetails: '/order/xs/saveDetails',
  // 销售子订单作废
  cancelXsDetails: '/order/xs/cancelDetails',
  // 获取客户可用余额
  getXsOrderBalance: '/order/xs/getXsOrderBalance',
  // 改变子订单状态(开票相关,包括子订单关闭、提交、开票以及收票)
  changeDetailsStatus: '/order/xs/changeDetailsStatus',

  orderExportPage: '/order/xs/exportPage',

  // 采购订单分页查询
  cgOrderPage: '/order/cg/page',
  // 生成采购订单单号
  genCgOrderNo: '/order/cg/genOrderNo',
  // 采购订单保存
  saveOrderCg: '/order/cg/save',
  // 采购订单作废
  cancelOrderCg: '/order/cg/cancel',
  // 采购订单审核
  auditOrderCg: '/order/cg/audit',
  // 采购子订单保存
  saveCgDetails: '/order/cg/saveDetails',
  // 采购子订单作废
  cancelCgDetails: '/order/cg/cancelDetails',

 
  // 收款分页查询
  receiptPage: '/receipt/page',

  // 收款单保存
  saveReceipt: '/receipt/save',

  // 客户统计
  orderXsStatsPage: '/order/xs/statsPage',

}

export default api

export function xsOrderPage(parameter) {
  return axios({
    url: api.xsOrderPage,
    method: 'post',
    data: parameter
  })
}

export function genXsOrderNo (parameter) {
  return axios({
    url: api.genXsOrderNo,
    method: 'get',
    params: parameter
  })
}

export function saveOrderXs(parameter) {
  return axios({
    url: api.saveOrderXs,
    method: 'post',
    data: parameter
  })
}

export function cancelOrderXs(parameter) {
  return axios({
    url: api.cancelOrderXs,
    method: 'post',
    data: parameter
  })
}

export function auditOrderDetailsXs(parameter) {
  return axios({
    url: api.auditOrderDetailsXs,
    method: 'post',
    data: parameter
  })
}

export function saveXsDetails(parameter) {
  return axios({
    url: api.saveXsDetails,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function queryOrderXs (parameter) {
  return axios({
    url: api.queryOrderXs,
    method: 'post',
    data: parameter
  })
}

export function cancelXsDetails(parameter) {
  return axios({
    url: api.cancelXsDetails,
    method: 'post',
    data: parameter
  })
}

export function changeDetailsStatus(parameter) {
  return axios({
    url: api.changeDetailsStatus,
    method: 'post',
    data: parameter
  })
}


export function orderExportPage (parameter) {
  return axios({
    url: api.orderExportPage,
    method: 'post',
    data: parameter
  })
}
/////////////////////////////////////////////////////////////////////////////
export function cgOrderPage(parameter) {
  return axios({
    url: api.cgOrderPage,
    method: 'post',
    data: parameter
  })
}

export function genCgOrderNo (parameter) {
  return axios({
    url: api.genCgOrderNo,
    method: 'get',
    params: parameter
  })
}

export function saveOrderCg(parameter) {
  return axios({
    url: api.saveOrderCg,
    method: 'post',
    data: parameter
  })
}

export function cancelOrderCg(parameter) {
  return axios({
    url: api.cancelOrderCg,
    method: 'post',
    data: parameter
  })
}

export function auditOrderCg(parameter) {
  return axios({
    url: api.auditOrderCg,
    method: 'post',
    data: parameter
  })
}

export function saveCgDetails(parameter) {
  return axios({
    url: api.saveCgDetails,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function queryOrderCg (parameter) {
  return axios({
    url: api.queryOrderCg,
    method: 'post',
    data: parameter
  })
}

export function cancelCgDetails(parameter) {
  return axios({
    url: api.cancelCgDetails,
    method: 'post',
    data: parameter
  })
}

export function receiptPage(parameter) {
  return axios({
    url: api.receiptPage,
    method: 'post',
    data: parameter
  })
}

export function saveReceipt(parameter) {
  return axios({
    url: api.saveReceipt,
    method: 'post',
    data: parameter
  })
}


export function getXsOrderBalance (parameter) {
  return axios({
    url: api.getXsOrderBalance,
    method: 'get',
    params: parameter
  })
}

export function orderXsStatsPage(parameter) {
  return axios({
    url: api.orderXsStatsPage,
    method: 'post',
    data: parameter
  })
}
